import {
    REGISTER_RENTAL_OPERATOR_START,
    REGISTER_RENTAL_OPERATOR_SUCCESS,
    REGISTER_RENTAL_OPERATOR_ERROR,
    COMMON_FORM_STEPPER_SUCCESS
} from "../../../Constant"

const initialState = {
    loading: false,
    data: null,
    message: "",
    currentStep: 0
};


export default function authReducer(state = { ...initialState }, action) {
    switch (action.type) {
        case REGISTER_RENTAL_OPERATOR_START:
            return {
                ...state,
                loading: true,
            };
        case REGISTER_RENTAL_OPERATOR_SUCCESS:
            return {
                ...state,
                ...action.payload,
                loading: false,
            };
        case REGISTER_RENTAL_OPERATOR_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
        case COMMON_FORM_STEPPER_SUCCESS:
            return {
                currentStep: state.currentStep + 1
            }
        default:
            return state;
    }
}
